module.exports = __webpack_public_path__ + "static/nvidia_logo-7bb3e5659f8702bd8ac9a6ac312da74e.png";